import React, { ChangeEvent, FunctionComponent, useEffect, useState } from "react";
import Select from 'react-select'
import { customSelectStyles } from "./utils/react-select-styles";

interface Props {
    contractRefNos: Contract[];
    selectedContractRefNo: string;
    onContractRefNoChanged: (newValue: string) => void;
}

interface Contract
{
    refNo: string;
    description: string;
}

export const ContractRefNoSelectBox: FunctionComponent<Props> = ({ contractRefNos, selectedContractRefNo, onContractRefNoChanged }) => {
    const defaultValue: Contract = { refNo: "", description: "" };
    return (
        <Select<Contract> name="contract-ref-no" options={contractRefNos} className="custom-select"
            getOptionLabel={cr => formatContract(cr)}
            getOptionValue={cr => cr.refNo}
            defaultValue={defaultValue}
            value={contractRefNos.find(cr => cr.refNo === selectedContractRefNo) || defaultValue}
            onChange={e => onContractRefNoChanged(e?.refNo || "")}
            menuPortalTarget={document.body}
            styles={customSelectStyles}/>
    )
}

function formatContract(contractRefNo:Contract) : string
{
    if(contractRefNo.description != ''){
        return `${contractRefNo.refNo} - ${contractRefNo.description}`;
    }else {
        return contractRefNo.refNo;
    }
}